const escapeHtml = (text) => {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
};

const parseInline = (text) => {
  let html = escapeHtml(text);

  // Bold: **text**
  html = html.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");

  // Italic: *text* (but not inside bold)
  html = html.replace(/(?<!\*)\*(?!\*)(.+?)(?<!\*)\*(?!\*)/g, "<em>$1</em>");

  return html;
};

export const markdownToHtml = (markdown) => {
  if (!markdown) return "";

  const lines = markdown.split(/\r?\n/);
  let html = "";
  let inList = false;

  const closeList = () => {
    if (inList) {
      html += "</ul>";
      inList = false;
    }
  };

  lines.forEach((line) => {
    const trimmed = line.trim();

    if (trimmed === "") {
      closeList();
      return;
    }

    // Headings
    if (trimmed.startsWith("# ")) {
      closeList();
      html += `<h1>${parseInline(trimmed.substring(2))}</h1>`;
      return;
    }

    if (trimmed.startsWith("## ")) {
      closeList();
      html += `<h2>${parseInline(trimmed.substring(3))}</h2>`;
      return;
    }

    if (trimmed.startsWith("### ")) {
      closeList();
      html += `<h3>${parseInline(trimmed.substring(4))}</h3>`;
      return;
    }

    // List items
    if (trimmed.startsWith("- ") || trimmed.startsWith("* ")) {
      if (!inList) {
        html += "<ul>";
        inList = true;
      }
      html += `<li>${parseInline(trimmed.substring(2))}</li>`;
      return;
    }

    // Regular paragraph
    closeList();
    html += `<p>${parseInline(trimmed)}</p>`;
  });

  closeList();

  return html;
};
